import { Component, Input, signal, WritableSignal, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

export interface NoticeConfig {
    icon: string;
    title?: string;
    message: string;
    hyperlink?: {
        text: string;
        route: string;
    };
}

/*
 The NoticeComponent is intended as a reusable component to display any stationery message on a page with an icon, title, message, and optional hyperlink.

 It accepts a configuration object via the `config` input, which determines the icon, title, message, hyperlink, and visibility of the notice.
 */
@Component({

         changeDetection: ChangeDetectionStrategy.Eager,

    selector: 'lib-notice',
    imports: [RouterModule],
    templateUrl: './notice.component.html',
    styleUrls: ['./notice.component.scss']
})
export class NoticeComponent implements OnChanges {
    isVisible: WritableSignal<boolean> = signal(true);
    @Input() config: NoticeConfig;
    sanitizedLink: string = '';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['config']) {
            if (this.config?.hyperlink) {
                // RouterLink handles its own security, no need to sanitize
                this.sanitizedLink = this.config.hyperlink.route ?? '';
            } else {
                this.sanitizedLink = '';
            }
        }
    }
}
